import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgModelAi = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M11.957 1C12.3026 1.0002 12.5829 1.28037 12.583 1.62598V4.13086H15.8701L15.9502 4.13477C16.3445 4.17507 16.6522 4.50823 16.6523 4.91309V8.2002H18.374C18.7197 8.20026 18.9999 8.48048 19 8.82617C18.9999 9.17184 18.7197 9.45209 18.374 9.45215H16.6523V11.3301H18.374C18.7196 11.3301 18.9998 11.6105 19 11.9561C19 12.3018 18.7198 12.582 18.374 12.582H16.6523V15.8701L16.6484 15.9502C16.6108 16.3181 16.3181 16.6109 15.9502 16.6484L15.8701 16.6523H12.583V18.374C12.5829 18.7196 12.3026 18.9998 11.957 19C11.6113 18.9999 11.3311 18.7197 11.3311 18.374V16.6523H9.45215V18.374C9.45209 18.7197 9.17189 19 8.82617 19C8.48048 18.9999 8.20026 18.7197 8.2002 18.374V16.6523H4.91309C4.50827 16.6521 4.17513 16.3444 4.13477 15.9502L4.13086 15.8701V12.582H1.62598C1.28025 12.582 1 12.3018 1 11.9561C1.00023 11.6105 1.28039 11.3301 1.62598 11.3301H4.13086V9.45215H1.62598C1.28032 9.45209 1.00012 9.17182 1 8.82617C1.00006 8.48048 1.28029 8.20026 1.62598 8.2002H4.13086V4.91309C4.13107 4.48117 4.48117 4.13107 4.91309 4.13086H8.2002V1.62598C8.20026 1.28029 8.48048 1.00006 8.82617 1C9.1719 1.00002 9.45209 1.28026 9.45215 1.62598V4.13086H11.3311V1.62598C11.3311 1.28029 11.6113 1.00006 11.957 1ZM5.69629 15.0869H15.0869V5.69629H5.69629V15.0869Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgModelAi);
export { ForwardRef as ReactComponent };
